import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const MediaGalleryModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "MediaGalleryModalContainer" */
      './MediaGalleryModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
